import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import {
  IAPIGameInfo,
  IAPIGameItem,
  IAPIReqUpdateGameInfo,
  IGameParam,
  IFavoriteParam,
  IMyFavoriteItem,
  IFavoriteTotalItem,
} from '../../model/api-modules/game';
import { API_PREFIX, INGAME_CONSOLE_PROXY_PREFIX_GAME } from '../config';
import { IStudioInfo } from '../../model/api-modules';
import { messageError } from '../../components/message';

// 获取游戏列表
export const fetchGameList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/game-studio-collection`;
      const response = await api.commonRequest('GET', url);
      // const res = await parsedResponse<IAPIGameItem[]>(response, 'data');

      // gameID为0脏数据临时解决
      const result = await parsedResponse<IAPIGameItem[]>(response, 'data');
      const res: IAPIGameItem[] = [];
      result.forEach((item: any) => {
        if (item.gameID === '0') {
          const resItem = {
            ...item,
            gameColor: null,
            gameCreateTime: null,
            gameID: null,
            gameIconUrl: null,
            gameKey: null,
            gameName: null,
          };
          res.push(resItem);
        } else {
          res.push(item);
        }
      });
      if (res.length > 0) {
        return res.sort((a, b) =>
          b.gameCreateTime > a.gameCreateTime ? -1 : 1
        );
      }
      return [];
    } catch (err) {
      if (err instanceof APIError) {
        messageError(err.message);
      }
      return null;
    }
  });

// 更新游戏
export const updateGameInfo = (data: IAPIReqUpdateGameInfo) =>
  withAPIAccount(AccountType.auto, async (api): Promise<boolean> => {
    try {
      const url = `${API_PREFIX}/games/update`;
      const response = await api.commonRequest('POST', url, data);
      const res = await parsedResponse(response, 'data');
      if (res) {
        return true;
      }
      return false;
    } catch (error) {
      console.log('failed: updateGameInfo', error);
      if (error instanceof APIError) {
        messageError(error.message);
      }
      return false;
    }
  });

// 创建游戏
export const createGame = (data: IGameParam) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/create`;
      const response = await api.commonRequest('POST', url, data);
      const res = await parsedResponse<any>(response, 'code');
      return res;
    } catch (error: any) {
      return error?.apiError?.code;
    }
  });

// 删除游戏
export const deleteGame = (gameID: string) =>
  withAPIAccount(AccountType.auto, async (api): Promise<boolean> => {
    try {
      const url = `${API_PREFIX}/games/${gameID}`;
      const response = await api.commonRequest('DELETE', url, { gameID });
      const res = await parsedResponse(response, 'code');
      return res === 0;
    } catch (error) {
      return false;
    }
  });

// 游戏-生成游戏 id 和 key
export const getGameKeyId = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    const url = `${API_PREFIX}/games/generate-identity`;
    const response = await api.commonRequest('POST', url);
    const res = await parsedResponse<IAPIGameInfo>(response, 'data');
    return res;
  });

export const getStudioInfoByGameID = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/${studioId}/studio-info`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<{ studioItem: IStudioInfo }>(
        response,
        'data'
      );
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        messageError(err?.apiError?.message);
      }
      return null;
    }
  });

// 获取所有服务收藏数据
export const getGameFavoriteTotal = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/service/favorite`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<ReadonlyArray<IFavoriteTotalItem>>(
        response,
        'data'
      );
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        messageError(err?.apiError?.message);
      }
      return [];
    }
  });

// 获取个人收藏列表
export const getServiceMyFavorite = (gameID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/service/my-favorite?gameID=${gameID}`;
      const response = await api.commonRequest('GET', url);
      return await parsedResponse<ReadonlyArray<IMyFavoriteItem>>(
        response,
        'data'
      );
    } catch (err: any) {
      if (err instanceof APIError) {
        messageError(err?.apiError?.message);
      }
      return [];
    }
  });

// 收藏、取消收藏
export const createRemoveFavorites = (data: IFavoriteParam) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/service/favorite`;
      const response = await api.commonRequest('POST', url, data);
      const res = await parsedResponse(response, 'data');
      if (res) {
        return true;
      }
      return false;
    } catch (err: any) {
      return false;
    }
  });

export const getImportCosConfig = (
  gameId: string,
  envId: string,
  envGuid: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${INGAME_CONSOLE_PROXY_PREFIX_GAME}/v1/api/k8s/gaas/cloud_file_cos/get_tmpsecret?operate_path=/${gameId}/env_import/*&game_id=${gameId}&env_id=${envGuid}&gameID=${gameId}&envID=${envId}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<any>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return;
    }
  });
